import React, { Fragment, useEffect, useState } from "react";
import { FnBlock_UI } from 'components/BlockUI';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { ColumnProps } from "components/TableUI/TableUI";
import { BtnAddTable, BtnCancel, BtnDeleteTable, BtnEditTable, BtnPDFTable, BtnSearchTable } from "components/Button";
import { Chip, Grid } from "@mui/material";
import TableUI from "components/TableUI";
import { useLocation, useNavigate } from "react-router-dom";
import { SelectMultipleFormItem, TextBoxForm } from "components/Input";

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { DatePickerFromItem } from "components/Input/DatePicker";
import { HiChip } from "react-icons/hi";
import Pupput from "./Pupput";
import { DeleteUserRecruitment, GetDataAll, LoadDataToTable, onCheckEditItem } from "./CallAPI";
import { Encrypt, undefinedOrNull } from "utilities/Function";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { SwAlert } from "components";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#0053b5",
        color: theme.palette.common.white,
        border: '1px solid rgba(224, 224, 224, 1) !important',
        padding: '10px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: '8px',
        border: '1px solid rgba(224, 224, 224, 1) !important',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function Recruitment_List() {
    //#region State
    const navigate = useNavigate();
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [IsView, SetIsView] = useState(false);
    const [ArrStatus, SetArrStatus] = useState([] as any);
    const [open, setOpen] = React.useState(false);
    const [sIDCard, setsIDCard] = React.useState("");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rowsData, setrowsData] = React.useState([]);
    const [lstDataEditItem, setlstDataEditItem] = React.useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setendDate] = useState(null);
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    //#endregion

    //#region Form YUP
    const objSchema = yup.object().shape({
        s1: yupFormSchemas.string("เลขที่ใบสมัคร", { required: false }),
        s2: yupFormSchemas.string("เลขที่บัตรประชาชน", { required: false }),
        sUserName: yupFormSchemas.string("ชื่อ-นามสกุล", { required: false }),
        sDate: yupFormSchemas.datetime("ช่วงวันที่สมัคร", { required: false }),
        sStatus: yupFormSchemas.string("สถานะ", { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(objSchema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError",
    });
    //#endregion

    //#region Column
    const ColumnData: ColumnProps[] = [
        {
            id: "nNo",
            name: "ลำดับ",
            width: "5%",
            cellAlign: "center",
        },
        {
            id: "sUrlImg",
            name: "",
            width: "5%",
            cellAlign: "center"
        },
        {
            id: "sRegisterCode",
            name: "เลขที่ใบสมัคร",
            width: "5%",
            cellAlign: "center"
        },
        {
            id: "sIDCard",
            name: "เลขที่บัตรประชาชน",
            width: "8%",
            cellAlign: "center"
        },
        {
            id: "sName",
            name: "ชื่อ - นามสกุล",
            width: "40%",
            cellAlign: "left"
        },
        {
            id: "sPositionName",
            name: "ตำแหน่งที่สนใจ",
            width: "20%",
            cellAlign: "left"
        },
        {
            id: "nStatusID",
            name: "สถานะ",
            width: "15%",
            cellAlign: "center",
        },
        {
            id: "sRegisterDate",
            name: "วันที่สมัคร",
            width: "15%",
            cellAlign: "center"
        },
        {
            id: "sUpdateDate",
            name: "วันที่แก้ไข",
            width: "15%",
            cellAlign: "center"
        },
        {
            id: "sUpdateByName",
            name: "ผู้แก้ไข",
            width: "15%",
            cellAlign: "center"
        },
        {
            id: "Button",
            name: "",
            width: "8%",
            cellAlign: "center",
        }
    ];
    //#endregion

    //#region FN
    const onEdit = (sID, sMode) => {
        // setOpen(true)
        let sUrl = "/UserRecruitment_From";
        // navigate(sUrl, { state: { sID: sID, sMode: sMode } }); //sMode (Add/Edit/View)
        navigate("/UserRecruitment_From?str=" + Encrypt(sID))
    }

    const onDelete = (nID) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
            DeleteUserRecruitment({ nID: nID }, () => {
                SwAlert.Success(AlertTitle.Success, AlertMsg.DeleteComplete, () => { _LoadDataToTable(); });
            }, BlockUI, UnBlockUI);
        });
    }

    // const onPDF = (nID) => {
    // }
    //#endregion

    useEffect(() => {
        _GetDataAll();
        _LoadDataToTable();
    }, []);
    const _GetDataAll = () => {
        GetDataAll((res) => {
            SetArrStatus(res.lstStatus || [])

        });
    };
    const _LoadDataToTable = () => {
        let obj = {
            sCodeUser: undefinedOrNull(form.getValues("sCode"), "string"),
            sNameUser: undefinedOrNull(form.getValues("sUserName"), "string"),
            sDateStart: undefinedOrNull(form.getValues("dStart"), "dateToString"),
            sDateEnd: undefinedOrNull(form.getValues("dEnd"), "dateToString"),
            lstStatus: form.getValues("lstStatus") || []
        }

        LoadDataToTable(obj, (res) => {
            setrowsData(res);
        }, BlockUI, UnBlockUI)
    }
    const _onClickEditIte = (ID, sIDCard) => {
        onCheckEditItem({ sCodeUser: sIDCard }, (res) => {
            if (res.isItem) {
                setsIDCard(sIDCard);
                setOpen(true);
                setlstDataEditItem(res.lstData || [])
            } else {
                onEdit(ID, "Edite")
            }
        }, BlockUI, UnBlockUI);
    }
    return (
        <FormProvider {...form}>
            <Grid container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
                <Grid container direction="row" spacing={2} justifyContent="start" alignItems="start">
                    <Grid item xs={12} md={12} container direction="row" spacing={1} justifyContent="right" alignItems="start">
                        <Grid item xs={12} md={3}>
                            <TextBoxForm
                                name='sCode'
                                label='เลขที่ใบสมัคร / เลขที่บัตรประชาชน'
                                fullWidth
                                maxLength={100}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2.3}>
                            <TextBoxForm
                                name='sUserName'
                                label='ชื่อ-นามสกุล'
                                fullWidth
                                maxLength={150}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <DatePickerFromItem
                                name='dStart'
                                label='วันที่สมัคร'
                                openTo="day"
                                maxDate={endDate}
                                disabled={false}
                                onChange={(e) => {
                                    setStartDate(e);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <DatePickerFromItem
                                name='dEnd'
                                label='ถึงวันที่'
                                openTo="day"
                                minDate={startDate}
                                disabled={false}
                                onChange={(e) => {
                                    setendDate(e);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <SelectMultipleFormItem
                                name='lstStatus'
                                label='สถานะ'
                                fullWidth
                                options={ArrStatus}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item >
                            <BtnSearchTable onClick={() => { _LoadDataToTable() }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12}>
                    <Paper sx={{ width: '100%' }}>
                        <TableContainer sx={{ maxHeight: 600 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <StyledTableRow>
                                        {ColumnData.map((column) => (
                                            <StyledTableCell
                                                key={column.id}
                                                align={"center"}
                                                style={{ minWidth: column.width }}
                                            >
                                                {column?.name}
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {rowsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                        return (
                                            <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.nID}>
                                                {ColumnData.map((column) => {
                                                    const value = row[column.id];
                                                    let sStatusbackgroundColor = "";
                                                    let sStatuColors = "";
                                                    switch (row.nStatusID) {
                                                        case 85: {
                                                            sStatusbackgroundColor = "rgb(255 248 233)";
                                                            sStatuColors = "rgb(165, 94, 0)";
                                                        }
                                                            break;
                                                        case 109: {
                                                            sStatusbackgroundColor = "rgb(19 191 0)";
                                                            sStatuColors = "rgb(185 255 157)"
                                                        }
                                                            break;
                                                        case 110: {
                                                            sStatusbackgroundColor = "#FF6969";
                                                            sStatuColors = "#F1EFEF"
                                                        }
                                                            break;
                                                        case 111:
                                                        case 112: {
                                                            sStatusbackgroundColor = "#D83F31";
                                                            sStatuColors = "#F1EFEF"
                                                        }
                                                            break;
                                                    }
                                                    return (
                                                        <>
                                                            {column.id === "Button" ?
                                                                <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                    <div style={{ display: "inline-flex", textAlign: "center" }}>
                                                                        {/* <BtnPDFTable title="เอกสาร" onClick={() => onPDF(row.nID)} /> */}
                                                                        <BtnEditTable title="แก้ไขข้อมูล" style={{ marginLeft: "5px" }} onClick={() => _onClickEditIte(row.nID, row.sIDCard)} />
                                                                        {row.isDelete&&<BtnDeleteTable title="ลบข้อมูล" style={{ marginLeft: "5px" }} onClick={() => onDelete(row.nID)} />}
                                                                    </div>
                                                                </StyledTableCell>
                                                                :
                                                                (column.id === "nStatusID" ?
                                                                    <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                        <Chip
                                                                            size="small"
                                                                            label={row.sStatusName}
                                                                            style={{
                                                                                color: sStatuColors,
                                                                                backgroundColor: sStatusbackgroundColor,
                                                                                margin: "0.2rem",
                                                                            }}
                                                                        />
                                                                    </StyledTableCell>
                                                                    : column.id === "sUrlImg" ?
                                                                        <StyledTableCell key={column.id} align={column.cellAlign} style={{ padding: "0" }}>
                                                                            <PhotoProvider>
                                                                                <PhotoView src={row.sUrlImg}>
                                                                                    <img src={row.sUrlImg} alt="Paris" width="50" height="50"
                                                                                        style={{
                                                                                            borderRadius: "8%",
                                                                                            boxShadow: "rgb(0, 0, 0, 0.35) 0px 5px 15px;",
                                                                                            marginTop: "6px",
                                                                                            cursor: "pointer"
                                                                                        }}></img>
                                                                                </PhotoView>
                                                                            </PhotoProvider>
                                                                        </StyledTableCell>
                                                                        :
                                                                        <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                            {value}
                                                                        </StyledTableCell>
                                                                )
                                                            }
                                                        </>
                                                    );
                                                })}
                                            </StyledTableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={rowsData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                </Grid>
                <Pupput open={open} lstDataEditItem={lstDataEditItem || []} handleClose={(e) => {
                    setOpen(false);
                    setsIDCard(null);
                }} sIDCard={sIDCard} />
            </Grid>
        </FormProvider>
    )
}